import React from 'react';
import { useShowController, useListContext } from 'react-admin';
import { Paper, Typography } from '@material-ui/core';
import { ReferenceManyField, Datagrid, TextField, NumberField, DateField, FunctionField, ReferenceField } from 'react-admin';
import useStyles from './styles';
import EmptyState from '../EmptyState';
import UserPurchaseOrdersTab from '../UserPurchaseOrders';

const CustomDatagridWithEmpty = ({ children, emptyMessage, ...props }) => {
  const { ids, loaded } = useListContext();
  if (!loaded) return null;
  if (!ids || ids.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }
  return <Datagrid {...props}>{children}</Datagrid>;
};

const PaymentsTab = props => {
    const { record, basePath, resource } = useShowController(props);
    const classes = useStyles();
    if (!record) return null;
    return (
      <>
        <UserPurchaseOrdersTab {...props} />
        <Paper className={classes.subscriptionCard} elevation={1}>
          <Typography variant="h6" className={classes.sectionTitle}>Subscription захиалгууд</Typography>
          <ReferenceManyField
            basePath={basePath}
            record={record}
            resource={resource}
            label="Subscription захиалгууд"
            reference="userSubscriptions"
            target="userId"
            sort={{ field: 'createdAt', order: 'DESC' }}
            perPage={5}
          >
            <CustomDatagridWithEmpty
              rowClick={() => {
                const filter = encodeURIComponent(JSON.stringify({ userId: record.id }));
                return `/userSubscriptions?filter=${filter}`;
              }}
              emptyMessage="Subscription захиалгууд алга байна."
            >
              <TextField source="id" />
              <TextField source="status" />
              <ReferenceField source="subscriptionPlanId" reference="subscriptionPlans" link={false}>
                <TextField source="type" />
              </ReferenceField>
              <DateField source="createdAt" showTime />
            </CustomDatagridWithEmpty>
          </ReferenceManyField>
        </Paper>
        <Paper className={classes.subscriptionCard} elevation={1}>
          <Typography variant="h6" className={classes.sectionTitle}>Төлбөрийн түүх</Typography>
          <ReferenceManyField
            basePath={basePath}
            record={record}
            resource={resource}
            label="Төлбөрийн түүх"
            reference="paymentLogs"
            target="userId"
            sort={{ field: 'createdAt', order: 'DESC' }}
            perPage={5}
          >
            <CustomDatagridWithEmpty
              rowClick={(id, bp, plRecord) => {
                const filter = encodeURIComponent(JSON.stringify({ invoiceNo: plRecord.invoiceNo }));
                return `/paymentLogs?filter=${filter}`;
              }}
              emptyMessage="Төлбөрийн түүх алга байна."
            >
              <TextField source="id" label="ID" />
              <TextField source="invoiceNo" label="Гүйлгээний ID" />
              <FunctionField render={r => (r.success === 0 ? 'APPROVED' : 'REJECTED')} />
              <DateField source="createdAt" showTime />
            </CustomDatagridWithEmpty>
          </ReferenceManyField>
        </Paper>
        <Paper className={classes.subscriptionCard} elevation={1}>
          <Typography variant="h6" className={classes.sectionTitle}>Төлбөрийн гүйлгээ</Typography>
          <ReferenceManyField
            basePath={basePath}
            record={record}
            resource={resource}
            label="Төлбөрийн гүйлгээ"
            reference="payments"
            target="userId"
            sort={{ field: 'createdAt', order: 'DESC' }}
            perPage={5}
          >
            <CustomDatagridWithEmpty
              rowClick={(id, bp, payRecord) => {
                const filter = encodeURIComponent(JSON.stringify({ invoiceNo: payRecord.invoiceNo }));
                return `/payments?filter=${filter}`;
              }}
              emptyMessage="Төлбөрийн гүйлгээ алга байна."
            >
              <TextField source="invoiceNo" />
              <NumberField source="amount" label="Дүн" />
              <NumberField source="totalAmount" label="Нийт дүн" />
              <TextField source="status" label="Төлөв" />
              <TextField source="productType" label="Бүтээгдэхүүн" />
              <TextField source="createdAt" label="Үүсгэсэн" showTime />
              <TextField source="provider" label="Үйлчилгээний төрөл" />
            </CustomDatagridWithEmpty>
          </ReferenceManyField>
        </Paper>
        <Paper className={classes.subscriptionCard} elevation={1}>
          <Typography variant="h6" className={classes.sectionTitle}>Carrier Billing Subscriptions</Typography>
          <ReferenceManyField
            basePath={basePath}
            record={record}
            resource={resource}
            label="Carrier Billing Subscriptions"
            reference="skills/carrierBillingSubscriptions"
            target="userId"
            sort={{ field: 'createdAt', order: 'DESC' }}
            perPage={5}
          >
            <CustomDatagridWithEmpty
              rowClick={() => {
                const filter = encodeURIComponent(JSON.stringify({ userId: record.id }));
                return `/skills/carrierBillingSubscriptions?filter=${filter}`;
              }}
              emptyMessage="Carrier Billing Subscriptions алга байна."
            >
              <TextField source="id" />
              <TextField source="referenceId" label="Reference Id" />
              <TextField source="phoneNumber" label="Утасны дугаар" />
              <TextField source="packageId" label="Package Id" />
              <TextField source="recurringPeriod" label="Төрөл" />
              <TextField source="status" label="Төлөв" />
              <TextField source="createdAt" label="Үүсгэсэн" showTime />
              <DateField source="expiredAt" label="Дуусах өдөр" showTime />
            </CustomDatagridWithEmpty>
          </ReferenceManyField>
        </Paper>
      </>
    );
  };

  export default PaymentsTab;